const SELF_MAILER = 'Self Mailer';
const REAL_PENNED_LETTER = 'Real Penned Letter';
const TEMPLATE_NAME_INPUT_SELECTOR = '.NewDesignSearch input';

const padDatePart = (value) => String(value).padStart(2, '0');

export const formatTemplateTimestamp = (date = new Date()) => {
  const hours = date.getHours();
  const displayHours = hours % 12 || 12;
  const period = hours >= 12 ? 'PM' : 'AM';

  return [
    `${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}-${date.getFullYear()}`,
    `${displayHours}:${padDatePart(date.getMinutes())} ${period}`,
  ].join(' ');
};

export const buildDefaultTemplateName = ({
  productType,
  productSize,
  designFormat,
  date = new Date(),
}) => {
  const namePrefix =
    productType === SELF_MAILER || productType === REAL_PENNED_LETTER
      ? designFormat
      : [productType, productSize].filter(Boolean).join(' ');

  return [namePrefix, formatTemplateTimestamp(date)].filter(Boolean).join(' ');
};

const getText = (element) => element?.textContent?.trim() || '';

const normalizeProductSize = (size) =>
  size
    .replaceAll('"', '')
    .replace(/\s*x\s*/i, 'x')
    .trim();

const getSelectedOption = (container, heading) => {
  const section = Array.from(container.querySelectorAll('.size-selection-container')).find(
    (element) => getText(element.querySelector('p')) === heading
  );

  return getText(section?.querySelector('.radio-button-wrapper.selected p'));
};

const setReactInputValue = (input, value) => {
  const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;

  valueSetter?.call(input, value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
};

export const installDefaultTemplateName = (container, date = new Date()) => {
  if (!container) {
    return () => {};
  }

  let selectedProductType = '';
  let syncTimeout;

  const syncTemplateName = () => {
    const input = container.querySelector(TEMPLATE_NAME_INPUT_SELECTOR);
    const activeProduct = container.querySelector('.product-card.active');

    if (!input) {
      return false;
    }

    selectedProductType ||= getText(activeProduct?.querySelector('p:last-child'));

    const productSize = normalizeProductSize(
      getText(container.querySelector('.product-thumbnail-details p:first-child span'))
    );
    const designFormat = getSelectedOption(container, 'Design Format');
    const requiresDesignFormat =
      selectedProductType === SELF_MAILER || selectedProductType === REAL_PENNED_LETTER;

    if (
      !selectedProductType ||
      (requiresDesignFormat ? !designFormat : !productSize || productSize === '-')
    ) {
      return false;
    }

    const title = buildDefaultTemplateName({
      productType: selectedProductType,
      productSize,
      designFormat,
      date,
    });

    if (title !== input.value) {
      setReactInputValue(input, title);
    }

    return true;
  };

  const scheduleSync = (retries = 20) => {
    const remainingRetries = typeof retries === 'number' ? retries : 20;

    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(() => {
      if (!syncTemplateName() && remainingRetries > 0) {
        scheduleSync(remainingRetries - 1);
      }
    }, 50);
  };

  const handleClick = (event) => {
    const productCard =
      event.target instanceof Element ? event.target.closest('.product-card') : null;

    if (productCard) {
      selectedProductType = getText(productCard.querySelector('p:last-child'));
    }

    scheduleSync();
  };

  const handlePointerDown = (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest('.buttons-container button.create-action')
    ) {
      syncTemplateName();
    }
  };

  container.addEventListener('click', handleClick);
  container.addEventListener('change', scheduleSync);
  container.addEventListener('pointerdown', handlePointerDown);
  scheduleSync();

  return () => {
    clearTimeout(syncTimeout);
    container.removeEventListener('click', handleClick);
    container.removeEventListener('change', scheduleSync);
    container.removeEventListener('pointerdown', handlePointerDown);
  };
};
